import { AES, enc } from 'crypto-js';
const storageKey = '&!5.8xMHTLH/c2M2';

export function loadState() {
  const savedState = sessionStorage.getItem('dmpst') || localStorage.getItem('dmpst');
  if (!savedState) {
    return {};
  }

  try {
    const decryptedData = AES.decrypt(savedState, storageKey).toString(enc.Utf8);
    return JSON.parse(decryptedData) || {};
  } catch {
    return {};
  }
}

export function saveState(state) {
  const encState = AES.encrypt(JSON.stringify(state), storageKey).toString();
  if (state.auth && state.auth.rememberMe) {
    localStorage.setItem('dmpst', encState);
    sessionStorage.removeItem('dmpst');
  } else {
    sessionStorage.setItem('dmpst', encState);
    localStorage.removeItem('dmpst');
  }
}
